<template>
  <div class="flex p-4 w-full justify-between">
    <div class="flex items-center">
      <ThemeImage
        v-if="email.prefixImage"
        :icon="email.prefixImage"
        alt="prefix"
        class="w-4 h-4"
      />
      <span class="ml-2.5">{{ email.text }}</span>
      <div v-if="email.is_purchased" class="selected_item_tag ml-1">
        GENERATED
      </div>
    </div>
    <div class="flex items-center">
      <div v-if="email.is_primary" class="action_button">Primary</div>
      <div class="flex" v-if="email.status === 'DISCONNECTED'">
        <ActionButton
          text="Reconnect"
          alt="warning"
          :src="imageNames.WARNING_TRIANGLE"
          :click="connectMailbox(email.vendor)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref } from "vue";
import ActionButton from "@/src/components/ActionButton.vue";
import DashboardService from "@/src/api/DashboardService.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const connectMailbox = (vendor) => {
  return async (event) => {
    try {
      if (vendor === "SMTP") {
        event.stopPropagation();
        emit("reconnectSmtp", email.value);
        return;
      }
      const response = await DashboardService.connectPersonalMailbox(vendor);
      if (response.success && response.redirect_url) {
        window.open(response.redirect_url);
      }
    } catch (error) {
      console.error("Error connecting mailbox:", error);
    }
  };
};

const props = defineProps(["value", "row"]);
const emit = defineEmits(["update", "reconnectSmtp"]);
const email = ref(props.value);
</script>
